/**
* Device.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
var Device = /** @class */ (function () {
    function Device() {
    }
    return Device;
}());
export { Device };
//# sourceMappingURL=Device.js.map